import {
  Box,
  Button,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import InputModal from "../../components/Modal/InputModal";
import { toast } from "react-toastify";
import ResetModal from "../../components/Modal/ResetModal";
import {
  useDeclareMutation,
  useResetAuctionMutation,
} from "../../services/auctionAPI";
import { useNavigate } from "react-router-dom";

const AuctionSetting = ({ auctionId, tournamentId, auctionDetails }) => {
  console.log(tournamentId, auctionDetails, "ppp");

  const [anchorEl, setAnchorEl] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [reason, setReason] = useState("");
  const [inputModal, setInputModal] = useState(false);
  const open = Boolean(anchorEl);
  const [resetModal, setResetModal] = useState(false);
  const [declare] = useDeclareMutation();
  const [resetAuction] = useResetAuctionMutation();
  const navigate = useNavigate();
  const [endModal, setEndModal] = useState(false);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const pause = async () => {
    const payload = {
      isPaused: true,
      isEnd: false,
      reason: reason,
      auctionId: auctionId,
    };
    try {
      const response = await declare(payload);
      if (response?.data?.success) {
        navigate("/auction/auction-details");
      }
    } catch (error) {
      setInputModal(false);
      toast.error(error?.data?.message || "Something went wrong");
    }
  };
  const resetCurrentStage = async () => {
    const payload = {
      tournamentId: tournamentId,
      auctionId: auctionId,
      allPhase: false,
      firstPhase: false,
      secondPhase: false,
      thirdPhase: false,
    };
    if (auctionDetails?.reauctionCount == 0) {
      payload.firstPhase = true;
    } else if (auctionDetails?.reauctionCount == 1) {
      payload.secondPhase = true;
    } else if (auctionDetails?.reauctionCount == 2) {
      payload.thirdPhase = true;
    }
    try {
      const response = await resetAuction(payload);
      console.log(response, "reset");

      if (response?.data?.success) {
        setResetModal(false);
        navigate("/auction/auction-details");
      }
    } catch (error) {
      setResetModal(false);
      toast.error(error?.data?.message || "Something went wrong");
    }
  };

  const reset = async () => {
    const payload = {
      tournamentId: tournamentId,
      auctionId: auctionId,
      allPhase: true,
      firstPhase: false,
      secondPhase: false,
      thirdPhase: false,
    };
    try {
      const response = await resetAuction(payload);
      if (response?.data?.success) {
        setResetModal(false);
        navigate("/auction/auction-details");
      }
    } catch (error) {
      setResetModal(false);
      toast.error(error?.data?.message || "Something went wrong");
    }
  };

  const end = async () => {
    const payload = {
      isPaused: false,
      isEnd: true,
      reason: reason,
      auctionId: auctionId,
    };
    try {
      const response = await declare(payload);
      if (response?.data?.success) {
        navigate("/auction/auction-details");
      }
    } catch (error) {
      setInputModal(false);
      toast.error(error?.data?.message || "Something went wrong");
    }
  };

  return (
    <Box>
      <Button
        sx={{
          background: colors.linearGradent,
          borderRadius: "1.5rem",
          py: "0.4rem",
          px: "1rem",
          textTransform: "capitalize",
          fontSize: ".9rem",
          color: "white",
          gap: ".5rem",
        }}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <img src={icons.setting} alt="icon" />
        Auction Settings
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 5,
            mt: 1,
            p: 0,
            minWidth: 320,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
            "& .MuiList-root": {
              padding: 0, // ✅ removes default Menu padding
            },
          },
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1,
            boxShadow: "0px 1px 16px 0px rgba(0, 0, 0, 0.11)",
          }}
        >
          <Typography
            fontWeight={600}
            display="flex"
            alignItems="center"
            gap={2}
            fontSize={"1.2rem"}
          >
            <img src={icons.blacksetting} alt="setting" />
            Settings
          </Typography>
        </Box>

        <Divider />

        <MenuItem
          onClick={() => {
            setConfirm(true);
          }}
        >
          <Typography sx={{ fontWeight: "600", fontSize: "1.1rem" }}>
            Pause Auction
          </Typography>
        </MenuItem>

        <Divider />

        <MenuItem
          onClick={() => {
            setResetModal(true);
          }}
        >
          <Typography sx={{ fontWeight: "600", fontSize: "1.1rem" }}>
            Reset Auction
          </Typography>
        </MenuItem>

        <Divider />

        <MenuItem sx={{ pb: ".7rem" }} onClick={() => setEndModal(true)}>
          <Typography sx={{ fontWeight: "600", fontSize: "1.1rem" }}>
            End Auction
          </Typography>
        </MenuItem>
      </Menu>
      <ConfirmModal
        open={confirm}
        onClose={() => setConfirm(false)}
        onConfirm={() => {
          setInputModal(true);
          setConfirm(false);
        }}
        title={"Are you sure you want to pause the Auction"}
      />
      <ConfirmModal
        open={endModal}
        onClose={() => setEndModal(false)}
        onConfirm={() => {
          setInputModal(true);
          // setEndModal(false);
        }}
        title={"Are you sure you want to end the Auction"}
      />
      <InputModal
        open={inputModal}
        onClose={() => {
          setEndModal(false);
          setInputModal(false);
        }}
        reason={reason}
        onConfirm={() => {
          if (!reason.trim()) {
            toast.warn("Enter the reason");
            return;
          }
          endModal ? end() : pause();
        }}
        setReason={setReason}
        title={
          endModal
            ? "Are you sure you want to end the Auction?"
            : "Reason for Auction Pausing"
        }
        placeholder={
          endModal
            ? "Enter reason for end auction"
            : "Enter reason for auction pause"
        }
      />
      <ResetModal
        open={resetModal}
        onClose={() => {
          setResetModal(false);
        }}
        onReset={reset}
        onResetCurrent={resetCurrentStage}
      />
    </Box>
  );
};

export default AuctionSetting;
